const HeaderMenuMobileIcon = (props) => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M44.2031 21.2031H1.79688C0.804461 21.2031 0 22.0076 0 23C0 23.9924 0.804461 24.7969 1.79688 24.7969H44.2031C45.1955 24.7969 46 23.9924 46 23C46 22.0076 45.1955 21.2031 44.2031 21.2031Z"
      fill="#FC7013"
    />
    <path
      d="M44.2031 6.82812H1.79688C0.804461 6.82812 0 7.63259 0 8.625C0 9.61741 0.804461 10.4219 1.79688 10.4219H44.2031C45.1955 10.4219 46 9.61741 46 8.625C46 7.63259 45.1955 6.82812 44.2031 6.82812Z"
      fill="#FC7013"
    />
    <path
      d="M44.2031 35.5781H1.79688C0.804461 35.5781 0 36.3826 0 37.375C0 38.3674 0.804461 39.1719 1.79688 39.1719H44.2031C45.1955 39.1719 46 38.3674 46 37.375C46 36.3826 45.1955 35.5781 44.2031 35.5781Z"
      fill="#FC7013"
    />
  </svg>
);

export default HeaderMenuMobileIcon;
